/* Follie by Alice — articoli del blog AroundMe (2026-10-05)
   1. riconosce il blocco con il testo dell'articolo (.fba-body)
   2. sposta in alto la fila "I N capi di questa guida" (renderizzata da follie-article-extras)
   3. aggiunge le ancore ai titoli H2 e l'indice "In questa guida" subito dopo l'introduzione
   4. trasforma le FAQ (H2 "FAQ"/"Domande frequenti" + domande in H3) in fisarmonica
   5. carica le altre foto del testo in alta risoluzione
   6. aggiorna prezzo e disponibilità nelle didascalie delle foto prodotto
   Caricato solo su request.page_type == 'article' (layout/theme.liquid). */
(function () {
  'use strict';

  function init() {
    var detail = document.querySelector('.blog-posts__detail');
    if (!detail) return;

    // 1. il blocco di testo con più paragrafi è il corpo dell'articolo
    var body = null;
    var best = 0;
    detail.querySelectorAll('.text-block, .rte').forEach(function (el) {
      var n = el.querySelectorAll(':scope > p').length;
      if (n > best) { best = n; body = el; }
    });
    if (!body || best < 2) return;
    body.classList.add('fba-body');

    moveStrip(body);
    var h2s = addAnchors(body);
    buildFaq(body, h2s);
    buildToc(body, h2s);
    upgradeImages(body);
    refreshPrices();
  }

  // 2. fila prodotti: subito prima del testo (dopo copertina e data)
  function moveStrip(body) {
    var strip = document.getElementById('fba-strip');
    if (!strip) return;
    body.parentNode.insertBefore(strip, body);
    var list = strip.querySelector('.fba-strip__list');
    strip.querySelectorAll('[data-fba-dir]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-fba-dir'), 10) || 1;
        list.scrollBy({ left: dir * list.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }

  // 3a. ancore sui titoli H2
  function slug(text) {
    return (text || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 70) || 'sezione';
  }
  function addAnchors(body) {
    var h2s = Array.prototype.slice.call(body.querySelectorAll(':scope > h2'));
    h2s.forEach(function (h) {
      if (h.id) return;
      var base = slug(h.textContent);
      var id = base;
      var i = 2;
      while (document.getElementById(id)) { id = base + '-' + i++; }
      h.id = id;
    });
    return h2s;
  }

  // 3b. indice dopo l'introduzione
  function buildToc(body, h2s) {
    if (h2s.length < 3) return;
    // c'è testo prima del primo H2? allora quella è l'introduzione
    var introBefore = false;
    for (var el = h2s[0].previousElementSibling; el; el = el.previousElementSibling) {
      if ((el.textContent || '').trim().length > 40) { introBefore = true; break; }
    }
    var items = introBefore ? h2s : h2s.slice(1);
    var anchor = introBefore ? h2s[0] : h2s[1];
    if (items.length < 3 || !anchor) return;

    var nav = document.createElement('nav');
    nav.className = 'fba-toc';
    nav.setAttribute('aria-label', 'Indice dell’articolo');
    var title = document.createElement('p');
    title.className = 'fba-toc__title';
    title.textContent = 'In questa guida';
    var ol = document.createElement('ol');
    ol.className = 'fba-toc__list';
    items.forEach(function (h) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var details = h.closest('details');
        if (details) details.open = true;
        h.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + h.id);
      });
      li.appendChild(a);
      ol.appendChild(li);
    });
    nav.appendChild(title);
    nav.appendChild(ol);
    body.insertBefore(nav, anchor);
  }

  // 4. FAQ a fisarmonica: ogni domanda (H3) con la sua risposta fino alla domanda successiva
  function buildFaq(body, h2s) {
    var faq = h2s.filter(function (h) {
      return /\bfaq\b|domande frequenti/i.test(h.textContent);
    })[0];
    if (!faq) return;
    var el = faq.nextElementSibling;
    while (el && el.tagName !== 'H2') {
      if (el.tagName === 'H3') {
        var details = document.createElement('details');
        details.className = 'fba-faq';
        var summary = document.createElement('summary');
        var answer = document.createElement('div');
        answer.className = 'fba-faq__answer';
        body.insertBefore(details, el);
        summary.appendChild(el);
        details.appendChild(summary);
        details.appendChild(answer);
        var n = details.nextElementSibling;
        while (n && n.tagName !== 'H2' && n.tagName !== 'H3') {
          var next = n.nextElementSibling;
          answer.appendChild(n);
          n = next;
        }
        el = details.nextElementSibling;
      } else {
        el = el.nextElementSibling;
      }
    }
  }

  // 5. foto del testo in alta risoluzione (le vecchie hanno il suffisso _600x600)
  function upgradeImages(body) {
    body.querySelectorAll('img').forEach(function (img) {
      if (img.closest('.follie-shop-figure')) return;
      var src = img.getAttribute('src') || '';
      if (/emoji/.test(src)) return;
      var m = src.match(/^(.*\/files\/[^?]+?)_(\d+)x(\d*)(\.(?:jpe?g|png|webp))(\?[^#]*)?$/i);
      if (!m) return;
      var hi = m[1] + m[4] + (m[5] ? m[5] + '&' : '?') + 'width=1200';
      img.addEventListener('error', function () { img.src = src; }, { once: true });
      img.src = hi;
      if (!img.getAttribute('loading')) img.setAttribute('loading', 'lazy');
    });
  }

  // 6. prezzo e disponibilità aggiornati nelle didascalie delle foto prodotto
  function euro(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }
  function refreshPrices() {
    var figures = document.querySelectorAll('.follie-shop-figure');
    if (!figures.length || !window.fetch) return;
    var byHandle = {};
    figures.forEach(function (fig) {
      var a = fig.querySelector('a[href*="/products/"]');
      if (!a) return;
      var handle = a.getAttribute('href').split('/products/')[1].split(/[?#/]/)[0];
      (byHandle[handle] = byHandle[handle] || []).push(fig);
    });
    Object.keys(byHandle).forEach(function (handle) {
      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          byHandle[handle].forEach(function (fig) {
            var price = fig.querySelector('.follie-shop-figure__price');
            var cta = fig.querySelector('.follie-shop-figure__cta');
            if (!price) return;
            if (!p.available) {
              fig.classList.add('is-sold-out');
              price.textContent = 'Esaurito';
              if (cta) cta.textContent = 'Vedi il capo';
              return;
            }
            var html = '';
            if (p.compare_at_price && p.compare_at_price > p.price) {
              html += '<s style="font-weight:400;opacity:.6;">' + euro(p.compare_at_price) + '</s> ';
            }
            if (p.price_varies) html += 'da ';
            price.innerHTML = html + euro(p.price);
          });
        })
        .catch(function () {});
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
